
const tabSystem = () => {
    const tabs = document.querySelectorAll('.tabs-custom');
    tabs.forEach(tab => {
        const tabsnaviitem = tab.querySelectorAll('.tabs-custom-navi__item:not(.--mobile)');
        const tabscontentitem = tab.querySelectorAll('.tabs-custom-content__item');
        const tabsnaviitemmobile = tab.querySelectorAll('.tabs-custom-navi__item.--mobile');

        if(window.innerWidth < 768){
            console.log(tabsnaviitemmobile.length);
            if(tabsnaviitemmobile.length > 1){
                tabscontentitem.forEach(element => {
                    element.classList.remove('active');
                });    
            
                tabsnaviitemmobile.forEach(element => {
                    element.classList.remove('active');
                }); 
            }
        }

        tabsnaviitemmobile.forEach((el, index) => {
            el.addEventListener('click', (e) => {
                let getIndice = index;
                if(el.classList.contains('--mobile')){
                    if(el.parentElement.classList.contains('active')){
                        
                        el.parentElement.classList.remove('active');
                        el.classList.remove('active'); 
                    } else {
                        tabscontentitem.forEach(element => { // rimuovo active da tutti
                            element.classList.remove('active');
                        });
                        tabsnaviitemmobile.forEach(element => { // rimuovo active da tutti
                            element.classList.remove('active');
                        });
                        el.parentElement.classList.add('active');
                        el.classList.add('active'); // do active a me
                        window.scrollTo({
                            top: el.parentElement.offsetTop-100,
                            behavior: "smooth"
                        });
                    }
                }
            });
        });

        tabsnaviitem.forEach((el, index) => {
            el.addEventListener('click', (e) => {
                if(!el.classList.contains('--mobile')){
                    let getIndice = index;
                    if ( document.querySelector('.tabs-custom.--bigger') ) {
    
                        if(el.classList.contains('active')){
                            el.classList.remove('active'); // do active a me
                            el.querySelector('.tabs-custom-navi__item-close').innerHTML = '<u>Scopri di più</u>';
                        }else{
                            tabsnaviitem.forEach(element => { // rimuovo active da tutti
                                element.classList.remove('active');
                            }); 
                            document.querySelectorAll('.tabs-custom-navi__item-close').forEach(element => {
                                element.innerHTML = '<u>Scopri di più</u>';
                            })
                            el.classList.add('active'); // do active a me
                            el.querySelector('.tabs-custom-navi__item-close').innerHTML = '<u>Chiudi</u>';
                        }

                        if(tabscontentitem[getIndice].classList.contains('active')){
                            tabscontentitem[getIndice].classList.remove('active');
                        }else{
                            tabscontentitem.forEach(element => { // rimuovo active da tutti
                                element.classList.remove('active');
                            });
                            tabscontentitem[getIndice].classList.add('active');
                        }
                        
                    } else {
                        tabsnaviitem.forEach(element => { // rimuovo active da tutti
                            element.classList.remove('active');
                        }); 
                        el.classList.add('active'); // do active a me
                        tabscontentitem.forEach(element => { // rimuovo active da tutti
                            element.classList.remove('active');
                        });
                        tabscontentitem[getIndice].classList.add('active');
                    }
                }
                
            });

        });
    });
 
}

export default tabSystem;
